/**
 * This functionality add custom tags into Head dynamically only for the Homepage
 */
import data from '../../../assets/data/head-tags-custom-homepage.js';
import { isDevEnvironment } from '../../../lib/isEditor.ts';
import { isDeveloperMode } from '../../utils.ts';

const getCurrentLanguageShort = () => {
  const htmlLang = document.querySelector('html').getAttribute('lang');
  const metaLanguage = document.querySelector('meta[name="language"]');
  const metaLanguageGet = metaLanguage?.content?.toLowerCase();
  const htmlLanguageGet = htmlLang?.toLowerCase();
  return metaLanguageGet || htmlLanguageGet;
};

function addHeadTags() {
  const subDomainsArray = decodeURI(window.location.pathname)
    .split('/')
    .filter(x => x);
  const isMultilingual = subDomainsArray[0] === getCurrentLanguageShort();
  const isHomePage = isMultilingual ? subDomainsArray.length === 1 : subDomainsArray.length === 0;
  const dataNormalized = Array.isArray(data) ? data : [];

  if (isHomePage) {
    const head = document.getElementsByTagName('head')[0];

    dataNormalized?.forEach(item => {
      const attributesArray = item?.attributes && Object.entries(item.attributes);
      const tag = item.tag ? document.createElement(item.tag) : document.createElement('meta');

      if (attributesArray && attributesArray.length) {
        attributesArray.forEach(attributeItem => {
          tag.setAttribute(attributeItem[0], attributeItem[1]);
        });
      }

      head.appendChild(tag);
    });
  }
}

if (!isDevEnvironment() || isDeveloperMode()) {
  addHeadTags();
}
